import type { TimelineSummaryData } from '../../../common/api/loyalty/externalLoyaltyModels';

const EMPTY_BONUS_2026_FLY_IN_TRIGGER_DATA = {
    bonusValueText: '0kr',
    progressPercent: 0,
    bonusProgressMonetaryText: '',
} as const;

type Bonus2026FlyInTriggerData = {
    bonusValueText: string;
    progressPercent: number;
    bonusProgressMonetaryText: string;
};

export type Bonus2026FlyInTriggerA11yInput = {
    label: string;
} & Omit<Bonus2026FlyInTriggerData, 'progressPercent'>;

export const getBonus2026FlyInTriggerLoadingAriaLabel = (label: string): string =>
    `${normalizeSentence(label)}, laddar.`;

export const getBonus2026FlyInTriggerAriaLabel = ({
    label,
    bonusValueText,
    bonusProgressMonetaryText,
}: Bonus2026FlyInTriggerA11yInput): string => {
    const headline = `${normalizeSentence(label)} ${bonusValueText}`.trim();

    if (bonusProgressMonetaryText) {
        return `${headline}, ${normalizeSentence(bonusProgressMonetaryText)}.`;
    }

    return `${headline}.`;
};

const normalizeSentence = (text: string) => text.replace(/[!.]+$/u, '').trim();

const getBonusProgressMonetaryText = (summary: TimelineSummaryData): string => {
    if (summary.isMaxLevel) {
        return 'Du har nått maxbonus den här månaden';
    }

    if (summary.amountUntilNextLevelKr > 0) {
        return `${summary.amountUntilNextLevelKr} kr till nästa nivå`;
    }

    return '';
};

const getCurrentLevelProgressPercent = (currentLevelProgress: number): number =>
    Math.max(0, Math.min(100, Math.round(currentLevelProgress * 100)));

export const getBonus2026FlyInTriggerData = (summaryData?: TimelineSummaryData) => {
    if (!summaryData) {
        return EMPTY_BONUS_2026_FLY_IN_TRIGGER_DATA;
    }

    return {
        bonusValueText: `${summaryData.monthlyBonusEarnedKr}kr`,
        progressPercent: getCurrentLevelProgressPercent(summaryData.currentLevelProgress),
        bonusProgressMonetaryText: getBonusProgressMonetaryText(summaryData),
    };
};
